module.exports = __webpack_public_path__ + "img/mall_06.27a00826.png";